import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { Fragment } from 'react';
import { PanelItemDivider } from '../../../panels/panelItemDivider';
import { useAppSelector } from '../../../redux/store';
import { MTT_STAGING_PLAYER_DIVIDER_COLOR } from '../../../styles/colors';
import { MttStagingPlayerDisplay } from './mttStagingPlayerDisplay';
import { MttStagingSubSection } from './mttStagingSubSection';
const SECTION_CSS = css `
  display: flex;
  flex-direction: column;
  padding-bottom: 5px;
`;
export const MttStagingPlayersSubSectionContainer = () => {
    const hasMttStagingTables = useAppSelector((state) => !!state.mttStaging.mttStagingTables.length);
    const players = useAppSelector((state) => state.mttStaging.players);
    if (hasMttStagingTables) {
        // if there are tables to display, it means the MTT has started, so don't render the section of (ready/not ready) players
        return null;
    }
    return (_jsx(MttStagingSubSection, { title: 'Players', children: _jsx("section", { "aria-label": 'ready players', css: SECTION_CSS, children: players.map((player, i) => {
                return (_jsxs(Fragment, { children: [i > 0 ? _jsx(PanelItemDivider, { color: MTT_STAGING_PLAYER_DIVIDER_COLOR, thicknessPx: 2 }) : null, _jsx(MttStagingPlayerDisplay, { player: player })] }, i));
            }) }) }));
};
